import React from "react";
import useChatBotService from "./service";
import "./chatBot.scss";
import { ChatBotArgsType } from "./type";

export default function ChatBot(props: ChatBotArgsType) {
  const { initializeChatBot, unInitializeBot } = useChatBotService(props);

  React.useEffect(() => {
    initializeChatBot();
    return () => unInitializeBot();
  }, [initializeChatBot, unInitializeBot]);

  return null;
}
